.padding-false {
  padding: 0;
}

/* Hack: antd Row/Col has broken vertical alignment without this padding. Remove if antd fixes it. */
.row-padding-hack {
  padding-top: 2px;
  padding-bottom: 2px;
}

:global(.ant-spin) {
  color: unset;
}

.viewport-height {
  height: 100vh;
}
